import { type ReactNode } from 'react'

/** The line under a To-dos row's title: a 12px glyph (or a wider run, like faces), then one truncated line of text. */
export function TodoRowSubtitle({ icon, text }: { icon: ReactNode; text: string | undefined }) {
  if (icon == null && text == null) return null
  return (
    <span className="text-foreground-secondary type-ui-xs flex min-w-0 items-center gap-1">
      {icon != null && <span className="flex h-3 min-w-3 shrink-0 items-center justify-center">{icon}</span>}
      {text != null && <span className="truncate">{text}</span>}
    </span>
  )
}
